import { getState } from '@/services/mfa'
export const MFASMSConfirm = (to: any, from: any) => {
    const { authenticationResult, username, session, sentTo } = getState()
    if ([authenticationResult, username, session, sentTo].includes(undefined)) {
        return { name: 'LoginView' }
    }
}
